import { render, staticRenderFns } from "./Provider.vue?vue&type=template&id=2c8bfb17&scoped=true"
import script from "./Provider.js?vue&type=script&lang=js&external"
export * from "./Provider.js?vue&type=script&lang=js&external"
import style0 from "./Provider.vue?vue&type=style&index=0&id=2c8bfb17&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8bfb17",
  null
  
)

export default component.exports